import { Component, ViewChild, OnInit } from '@angular/core';
import { LoadingBarService } from '@ngx-loading-bar/core';
import { ActivatedRoute, Router } from '@angular/router';
import { Globals } from 'app/_globals';
import { FormGroup, FormBuilder, FormControl, Validators } from '@angular/forms';
import { NotificationService } from 'app/_services/notification.service';
import { environment } from '../../environments/environment';
import { DynamicFormComponent } from '../_dynamic_form/containers/dynamic_form/dynamic-form.component';
import { GroupUserService } from '../_services/group-user.service';

@Component({
    selector: 'app-u-group-users',
    templateUrl: './u-group-users.component.html',
    styleUrls: ['./u-group-users.component.css']
})
export class UGroupUsersComponent implements OnInit {

    @ViewChild(DynamicFormComponent) filterForm: DynamicFormComponent;

    users: any[] = [];
    selectedUser: any;

    storeId: any;

    filters: any;

    sidebarVisible = false;
    createUserModal = false;
    createUserForm: FormGroup;
    errMsgs: any[] = [];

    pageSizes: any = environment.pageSizes;
    pagination: any;

    selectedSort: any;

    sortFields: any[] = [
        {
            sortName: 'First Name (asc)',
            sortString: 'bludotUser.user.firstName,asc'
        },
        {
            sortName: 'First Name (desc)',
            sortString: 'bludotUser.user.firstName,desc'
        },
        {
            sortName: 'Last Name (asc)',
            sortString: 'bludotUser.user.firstName,asc'
        },
        {
            sortName: 'Last Name (desc)',
            sortString: 'bludotUser.user.firstName,desc'
        },
        {
            sortName: 'Organisation Name (asc)',
            sortString: 'bludotUser.organisation,asc'
        },
        {
            sortName: 'Organisation Name (desc)',
            sortString: 'bludotUser.organisation,desc'
        }
    ];

    filterFields: any[] = [
        {
            type: 'input',
            label: 'First Name',
            name: 'firstName',
            placeholder: 'Enter first name'
        },
        {
            type: 'input',
            label: 'Last Name',
            name: 'lastName',
            placeholder: 'Enter last name'
        },
        {
            type: 'input',
            label: 'Email',
            name: 'email',
            placeholder: 'Enter email'
        },
        {
            type: 'input',
            label: 'Organisation',
            name: 'organisation',
            placeholder: 'Enter organisation name'
        },
        {
            label: 'Submit',
            name: 'submit',
            type: 'button'
        }
    ];

    constructor(
        public loader: LoadingBarService,
        public activatedRoute: ActivatedRoute,
        public router: Router,
        public globals: Globals,
        public fb: FormBuilder,
        public notificationService: NotificationService,
        public _groupUserService: GroupUserService
    ) {
        this.createUserForm = fb.group({
            firstName: new FormControl('', [Validators.required]),
            lastName: new FormControl('', [Validators.required]),
            email: new FormControl('', [Validators.required]),
            password: new FormControl('', [Validators.required]),
            repeatedPassword: new FormControl('', [Validators.required]),
            organisation: new FormControl('', [Validators.required])
        });

        this.storeId = globals.store.id;
        this.selectedSort = this.sortFields[0];
        this.resetPagination();
    }

    ngOnInit() {
        this.getAllGroups();
    }

    // Get All Groups
    public getAllGroups() {
        this._groupUserService.getAllGroups(this.pagination, this.selectedSort.sortString)
            .subscribe((data: any) => {
                this.users = data.body;
                this.pagination.totalRecords = data.headers.get('x-total-count');
            })
    }

    /* PAGINATION */
    public resetPagination() {
        this.pagination = {
            size: this.pageSizes[0],
            page: 0,
            totalRecords: 0
        }
    }

    paginate(event) {
        console.log(event);
        this.pagination.size = event.rows;
        this.pagination.page = event.page;
    }
    /* PAGINATION END */



    // Handle onRowSelect (ie Select Single Patient and navigate to inner view)
    onRowSelect(event) {
        // this.router.navigate(['/' + this.globals.user.routeRole + '/products/' + event.data.id]);
        console.log('onnRowSelect Clicked');
    }

    public toggleCreateUserModal() {
        this.createUserModal = !this.createUserModal;
    }

    public onCreateUserFormSubmit() {
        this.errMsgs = [];
        const values = this.createUserForm.value;
        if (values.password !== values.repeatedPassword) {
            this.errMsgs.push({severity: 'warn', summary: 'Passwords Do Not Match', detail: 'Passwords must match!'});
        } else {
            const body = {
                firstName: values.firstName,
                lastName: values.lastName,
                email: values.email,
                login: values.email,
                organisation: values.organisation,
                password: values.password
            };
            this._groupUserService.createGroup(body)
                .subscribe((data: any) => {
                    this.toggleCreateUserModal();
                    this.createUserForm.reset();
                    this.resetPagination();
                    this.getAllGroups();
                    this.notificationService.notify(
                        'success',
                        'Group Created',
                        'New group has been sucessfully created',
                        'top',
                        'right');
                })
        }
    }

    sortChange(event) {
        this.selectedSort = event;
        this.getAllGroups();
        this.resetPagination();
    }

    filterFormSubmitted(value) {
        this.sidebarVisible = false;
        this.filters = value;
        this.resetPagination();
    }


    clearFilters() {
        this.sidebarVisible = false;
        this.filters = '';
        this.filterForm.clearForm();
        this.resetPagination();
    }


}



// WEBPACK FOOTER //
// ./src/app/u-group-users/u-group-users.component.ts